import { createSlice } from '@reduxjs/toolkit';
import { isWishlistEligibleProduct } from '../../utils/productRules';


const loadWishlistFromStorage = () => {
  try {
    const wishlistData = localStorage.getItem('psh-wishlist');
    const parsed = wishlistData ? JSON.parse(wishlistData) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item) => isWishlistEligibleProduct(item));
  } catch (error) {
    return [];
  }
};

const saveWishlistToStorage = (wishlist) => {
  try {
    localStorage.setItem('psh-wishlist', JSON.stringify(wishlist));
  } catch (error) {
    // Failed to save wishlist to storage
  }
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    items: loadWishlistFromStorage(),
    loading: false,
    error: null,
  },
  reducers: {
    toggleWishlist: (state, action) => {
      const product = action.payload;
      const existingIndex = state.items.findIndex(item => item.id === product.id);

      if (existingIndex >= 0) {
        // Remove from wishlist
        state.items.splice(existingIndex, 1);
      } else {
        if (!isWishlistEligibleProduct(product)) {
          return;
        }

        // Add to wishlist
        state.items.push({
          id: product.id,
          name: product.name || product.Name,
          price: product.price,
          image: product.image || product['icon link'],
          category: product.category,
          Type: product.Type,
          type: product.type,
          ExternalLink: product.ExternalLink,
          externalLink: product.externalLink,
          pricingRaw: product.pricingRaw,
          Price: product.Price,
          addedAt: Date.now()
        });
      }

      saveWishlistToStorage(state.items);
    },
    clearWishlist: (state) => {
      state.items = [];
      try {
        localStorage.removeItem('psh-wishlist');
      } catch (e) {
        console.warn('LocalStorage access denied', e);
      }
    },
    removeFromWishlist: (state, action) => {
      const productId = action.payload;
      state.items = state.items.filter(item => item.id !== productId);
      saveWishlistToStorage(state.items);
      // Removed toast - let component handle it
    },
    setWishlistLoading: (state, action) => {
      state.loading = action.payload;
    },
    setWishlistError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

// Selectors
export const selectWishlistItems = (state) => state.wishlist?.items || [];
export const selectWishlistItemCount = (state) => state.wishlist?.items?.length || 0;
export const selectIsInWishlist = (state, productId) =>
  state.wishlist?.items?.some(item => item.id === productId) || false;

export const {
  toggleWishlist,
  clearWishlist,
  removeFromWishlist,
  setWishlistLoading,
  setWishlistError
} = wishlistSlice.actions;

export default wishlistSlice.reducer;
